/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receive_Cancellation_Email_ConfirmInputs */

const en_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll receive a cancelation confirmation email.`)
};

const id_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan menerima email konfirmasi pembatalan.`)
};

const ms_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan menerima emel pengesahan pembatalan.`)
};

const ca_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebràs un correu electrònic de confirmació de cancel·lació.`)
};

const cs_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obdržíte potvrzovací email o zrušení.`)
};

const da_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du vil modtage en bekræftelses-e-mail om annulleringen.`)
};

const de_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie erhalten eine Bestätigungs-E-Mail über die Kündigung.`)
};

const et_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saate tühistamise kinnitusmeili.`)
};

const es_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibirás un correo de confirmación de cancelación.`)
};

const fr_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous recevrez un e-mail de confirmation.`)
};

const hr_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primit ćete e-mail s potvrdom o otkazivanju.`)
};

const it_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riceverai un'email di conferma della cancellazione.`)
};

const lv_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūs saņemsiet anulējuma apstiprinājuma e-pastu.`)
};

const lt_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gausite el. laišką apie atšaukimo patvirtinimą.`)
};

const hu_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megerősítő emailt kap a lemondásról.`)
};

const nl_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je ontvangt een annuleringsbevestiging per e-mail.`)
};

const nb_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du får en bekreftelse på oppsigelsen via e-post.`)
};

const pl_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otrzymasz e-mail potwierdzający anulowanie subskrypcji.`)
};

const pt_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você receberá um e-mail de confirmação de cancelamento.`)
};

const ro_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veți primi un e-mail de confirmare a anulării.`)
};

const sk_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostanete potvrdzovací e-mail o zrušení.`)
};

const sl_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prejeli boste potrditveno e-poštno sporočilo o preklicu.`)
};

const fi_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat peruutusvahvistussähköpostin.`)
};

const sv_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kommer att få ett bekräftelsemail för avbokning.`)
};

const vi_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn sẽ nhận được email xác nhận hủy bỏ.`)
};

const tr_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir iptal onay e-postası alacaksınız.`)
};

const el_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Θα λάβετε ένα email επιβεβαίωσης ακύρωσης.`)
};

const bg_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ще получите имейл с потвърждение за анулиране.`)
};

const ru_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы получите электронное письмо с подтверждением отмены.`)
};

const sr_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примићете имејл потврду о отказивању.`)
};

const uk_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви отримаєте електронний лист із підтвердженням скасування.`)
};

const ka_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენ მიიღებთ გაუქმების დადასტურების მეილს.`)
};

const hi_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको रद्दीकरण की पुष्टि ईमेल प्राप्त होगी।`)
};

const th_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณจะได้รับอีเมลยืนยันการยกเลิก`)
};

const ko_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`취소 확인 이메일이 전송됩니다.`)
};

const zh_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您将会收到一封取消确认电子邮件。`)
};

const zh_tw_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您將收到一封取消確認電子郵件。`)
};

const ja_receive_cancellation_email_confirm = /** @type {(inputs: Receive_Cancellation_Email_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル確認メールが届きます。`)
};

/**
* | output |
* | --- |
* | "You'll receive a cancelation confirmation email." |
*
* @param {Receive_Cancellation_Email_ConfirmInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const receive_cancellation_email_confirm = /** @type {((inputs?: Receive_Cancellation_Email_ConfirmInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receive_Cancellation_Email_ConfirmInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_receive_cancellation_email_confirm(inputs)
	if (locale === "ms") return ms_receive_cancellation_email_confirm(inputs)
	if (locale === "ca") return ca_receive_cancellation_email_confirm(inputs)
	if (locale === "cs") return cs_receive_cancellation_email_confirm(inputs)
	if (locale === "da") return da_receive_cancellation_email_confirm(inputs)
	if (locale === "de") return de_receive_cancellation_email_confirm(inputs)
	if (locale === "et") return et_receive_cancellation_email_confirm(inputs)
	if (locale === "es") return es_receive_cancellation_email_confirm(inputs)
	if (locale === "fr") return fr_receive_cancellation_email_confirm(inputs)
	if (locale === "hr") return hr_receive_cancellation_email_confirm(inputs)
	if (locale === "it") return it_receive_cancellation_email_confirm(inputs)
	if (locale === "lv") return lv_receive_cancellation_email_confirm(inputs)
	if (locale === "lt") return lt_receive_cancellation_email_confirm(inputs)
	if (locale === "hu") return hu_receive_cancellation_email_confirm(inputs)
	if (locale === "nl") return nl_receive_cancellation_email_confirm(inputs)
	if (locale === "nb") return nb_receive_cancellation_email_confirm(inputs)
	if (locale === "pl") return pl_receive_cancellation_email_confirm(inputs)
	if (locale === "pt") return pt_receive_cancellation_email_confirm(inputs)
	if (locale === "ro") return ro_receive_cancellation_email_confirm(inputs)
	if (locale === "sk") return sk_receive_cancellation_email_confirm(inputs)
	if (locale === "sl") return sl_receive_cancellation_email_confirm(inputs)
	if (locale === "fi") return fi_receive_cancellation_email_confirm(inputs)
	if (locale === "sv") return sv_receive_cancellation_email_confirm(inputs)
	if (locale === "vi") return vi_receive_cancellation_email_confirm(inputs)
	if (locale === "tr") return tr_receive_cancellation_email_confirm(inputs)
	if (locale === "el") return el_receive_cancellation_email_confirm(inputs)
	if (locale === "bg") return bg_receive_cancellation_email_confirm(inputs)
	if (locale === "ru") return ru_receive_cancellation_email_confirm(inputs)
	if (locale === "sr") return sr_receive_cancellation_email_confirm(inputs)
	if (locale === "uk") return uk_receive_cancellation_email_confirm(inputs)
	if (locale === "ka") return ka_receive_cancellation_email_confirm(inputs)
	if (locale === "hi") return hi_receive_cancellation_email_confirm(inputs)
	if (locale === "th") return th_receive_cancellation_email_confirm(inputs)
	if (locale === "ko") return ko_receive_cancellation_email_confirm(inputs)
	if (locale === "zh") return zh_receive_cancellation_email_confirm(inputs)
	if (locale === "zh-tw") return zh_tw_receive_cancellation_email_confirm(inputs)
	if (locale === "ja") return ja_receive_cancellation_email_confirm(inputs)
	return en_receive_cancellation_email_confirm(inputs)
});